<div class="wrapper">
  <div class="main" [class.main-cst]="isSpecialPage" [class.after-login-dv]="isLogin" [class.mini-menu-shell-page]="isMiniMenuPage">
    <!-- when clicked why hungery main-cst otherwise not -->
    <!-- <app-ui-header></app-ui-header> -->
    <app-header *ngIf="!isMiniMenuPage" [isLogin]="isLogin"></app-header>
    <div class="main-content" #mainContent>
      <router-outlet></router-outlet>
    </div>
    <app-footer *ngIf="footerReady && !isMiniMenuPage" [isLogin]="isLogin"></app-footer>
  </div>
</div>
<app-loader *ngIf="!isMiniMenuPage"></app-loader>
